export class TimeoutError extends Error {
	constructor(label: string, timeoutMs: number) {
		super(`${label} did not finish within ${timeoutMs} ms`)
		this.name = 'TimeoutError'
	}
}

/**
 * Settles like `promise`, or rejects with a TimeoutError once `timeoutMs`
 * passed. The promise itself keeps running; only the wait for it ends.
 */
export const withTimeout = <T>(
	promise: Promise<T>,
	timeoutMs: number,
	label: string
): Promise<T> =>
	new Promise<T>((resolve, reject) => {
		const timer = setTimeout(
			() => reject(new TimeoutError(label, timeoutMs)),
			timeoutMs
		)
		promise.then(
			value => {
				clearTimeout(timer)
				resolve(value)
			},
			error => {
				clearTimeout(timer)
				reject(error)
			}
		)
	})
